"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Topic = void 0;
class Topic {
    constructor(name, _channelName, _logger) {
        this.name = name;
        this._channelName = _channelName;
        this._logger = _logger;
        this.MB_DEBUG_MODE = 'MB_DEBUG_MODE';
        this._subscribers = [];
        this.publishFormatter = ({ channel, topic, headers, data, handlers, timeStamp, error }) => `   
        ACTION: PUBLISH
        CHANNEL: ${channel}
        TOPIC: ${topic}
        HEADERS: ${JSON.stringify(headers)}
        DATA: ${data && JSON.stringify(data) || "No data."}
        ACTIVE SUBSCRIPTIONS: ${handlers}
        ERROR: ${error || "No errors."}
        TIMESTAMP: ${new Date()}
        `;
        this.subscribeFormatter = ({ channel, topic, activeSubscriptions, error }) => `   
        ACTION: SUBSCRIBE
        CHANNEL: ${channel}
        TOPIC: ${topic}
        ACTIVE SUBSCRIPTIONS: ${activeSubscriptions || 0}
        TIMESTAMP: ${new Date()}
        ${error && `ERROR: ${error}` || ""}
        `;
        this.unsubscribeFormatter = ({ channel, topic, activeSubscriptionsBefore, activeSubscriptionsAfter }) => `   
        ACTION: UNSUBSCRIBE
        CHANNEL: ${channel}
        TOPIC: ${topic}
        ACTIVE SUBSCRIPTIONS: BEFORE - ${activeSubscriptionsBefore || 0} | AFTER - ${activeSubscriptionsAfter || 0}
        TIMESTAMP: ${new Date()}
        `;
    }
    publish(headers, payload) {
        const clone = [...this._subscribers];
        clone.forEach(subscriberCallback => {
            try {
                const env = {
                    topic: this.name,
                    data: payload,
                    headers,
                    channel: this._channelName,
                    timeStamp: new Date()
                };
                subscriberCallback(payload, env);
            }
            catch (err) {
                this._logger.error(`Calling subscriber ${subscriberCallback} on topic ${this.name} in channel ${this._channelName} failed`, err);
            }
        });
        if (sessionStorage.getItem(this.MB_DEBUG_MODE)) {
            this._logger.info(this.publishFormatter({
                channel: this._channelName,
                data: payload,
                error: null,
                handlers: this._subscribers.length,
                headers,
                timeStamp: new Date(),
                topic: this.name
            }));
        }
    }
    subscribe(callback) {
        if (!callback && sessionStorage.getItem(this.MB_DEBUG_MODE)) {
            this._logger.warning(this.subscribeFormatter({ channel: this._channelName, topic: this.name, error: "Missing callback...", activeSubscriptions: "Not applicable." }));
        }
        this._subscribers.push(callback);
        if (sessionStorage.getItem(this.MB_DEBUG_MODE)) {
            this._logger.info(this.subscribeFormatter({ channel: this._channelName, topic: this.name, activeSubscriptions: this._subscribers.length }));
        }
        return {
            unsubscribe: () => {
                const activeSubscriptionsBefore = this._subscribers.length;
                const subscriberIndex = this._subscribers.findIndex(s => s == callback);
                if (subscriberIndex >= 0) {
                    this._subscribers.splice(subscriberIndex, 1);
                }
                const activeSubscriptionsAfter = this._subscribers.length;
                if (sessionStorage.getItem(this.MB_DEBUG_MODE)) {
                    this._logger.info(this.unsubscribeFormatter({
                        channel: this._channelName,
                        topic: this.name,
                        activeSubscriptionsBefore,
                        activeSubscriptionsAfter
                    }));
                }
            }
        };
    }
}
exports.Topic = Topic;
//# sourceMappingURL=topic.js.map